<template>
  <div>    
    <header v-if="windowSize>=992" class="sw-header sw-header-fixed" >      
      <b-navbar style="padding-left: 0;" toggleable="lg">
        <div class="logo">
          <div class="resumen" v-if="moraCliente">
            <b-link @click="resumenLink">Resumen</b-link>
            <span class="resumen-limite">Limite: 15/10/2020</span>
          </div>          
          <img v-else @click="oninit" style="cursor:pointer" title="Refrescar datos" src="/images/logo-white.svg">
        </div>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-navbar-nav class="sw-header-nav" style="position:relative">
          <b-nav-form style="margin-right:40px">
            <b-input-group size="sm"  prepend="Buscar afiliado:">
                <c-multiselect
                  class="buscarHeader"                
                  id="buscarHeader"
                  name="buscarHeader"
                  placeholder=""
                  v-model="buscarHeader"        
                  :options="filterSelects('datos_afiliado')"
                  :filterCampos="'name|documento'"
                  :customLabel="function (value) { return value.documento+' - '+value.name}"
                  :allow-empty="false"          
                  label="name"
                  @input="searchsHeaderFtn"
                  >
                </c-multiselect> 
                <b-input-group-append>
                  <b-button @click="buscarHeader=[];dataGet.header.data=[]" variant="secondary" style="height: 31px;" size="sm">X</b-button>
                </b-input-group-append>
            </b-input-group>
          </b-nav-form>
          <b-card v-if="buscarHeader>0" style="position:absolute;top:35px;z-index:20;background: rgb(250, 250, 250);    box-shadow: 0px 2px 9px 4px rgba(0, 0, 0, 0.08), 0px 3px 4px 0px rgba(0, 0, 0, 0.08), 0px 1px 7px 0px rgba(0, 0, 0, 0.08) !important;max-height: 500px;overflow:auto"  id="style-1"> 
            <sw-loading v-if="dataGet.header.data.length===0"></sw-loading>              
            <sw-tableheader
              v-if="dataGet.header.data.length>0"
              class="table-header-searchs"
              :tableItems="tableGBItems"
              :buscarProp="false"
              :options="false"
              name="tableheaderHeader"
              :paginationShow="false"
              >       
            </sw-tableheader>
          </b-card>
          <!-- Navbar dropdowns -->
        </b-navbar-nav> 
        <div style="width:375px;border-radius:3px;background:rgba(255,255,255,.9);margin-top:-7px">
          <b-row align-v="center">
            <b-col>
              <b-row>            
                <b-col :md="6" :lg="6">
                  Afiliaciones <span class="text-info " style="float:right;font-weight:500">{{conteoData.afiliaciones}}</span>
                </b-col>
                <b-col :md="6" :lg="6">
                  Aportes <span class="text-info " style="float:right;font-weight:500">{{conteoData.aportes}}</span>
                </b-col>
                <b-col :md="6" :lg="6">
                  Retiros <span class="text-danger " style="float:right;font-weight:500">{{conteoData.retiros}}</span>
                </b-col>
                <b-col :md="6" :lg="6">
                  Pendientes <span class="text-danger " style="float:right;font-weight:500">{{conteoData.pendientes}}</span>
                </b-col>
              </b-row>
            </b-col>
            <b-col :md="2" :lg="2">
              <b-icon id="popover-caluculado" icon="file-spreadsheet" variant="dark" scale="1.7"></b-icon>                        
              <b-popover target="popover-caluculado" triggers="click" placement="bottom">
                <template v-slot:title>Calculadora</template>
                  <b-input-group prepend="Salario" class="mt-3">
                    <vue-numeric 
                    separator="."   
                    class="form-control"   
                    :empty-value="0"        
                    id="'calculadora.salario"
                    name="'calculadora.salario"
                    v-model="salarioCalculadora"
                    :precision="0">
                  </vue-numeric>   
                  <b-button variant="outline-info" size="sm"  @click="calcularPrecio"><b-icon id="popover-caluculado" icon="file-spreadsheet" variant="dark" /></b-button>
                  <b-button variant="dark" size="sm"  @click="salarioCalculadora=baseCalculadora[0].base;calcularPrecio()"><b-icon id="popover-caluculado" icon="arrow-clockwise" variant="light" /></b-button>                 
                </b-input-group> 
                <table style="margin: auto;margin-top: 15px;">               
                  <tbody>
                    <tr>
                      <td>
                        <b-form-checkbox
                          id="calculadora.eps"
                          v-model="calculadora.eps"
                          name="calculadora.eps"
                          @input="calcularPrecio"
                        >  </b-form-checkbox></td>
                      <td>Eps</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>
                        <b-form-checkbox
                          id="calculadora.arl"
                          v-model="calculadora.arl"
                          name="calculadora.arl"
                          @input="calcularPrecio"
                        >  </b-form-checkbox></td>
                      <td>Riesgo</td>
                      <td>
                        <c-multiselect
                          style="display:inline-block;flex: 1 1 0%; margin-bottom:15px"   
                          v-model="calculadora.riesgo"                   
                          :options="lists.list_riesgo"
                          @input="calcularPrecio"
                          label="name"
                          track-by="name"
                          :allow-empty="false"
                          placeholder="Seleccionar"
                          >
                        </c-multiselect>
                    </td>
                    </tr>
                    <tr>
                      <td>
                        <b-form-checkbox
                          id="calculadora.ccf"
                          v-model="calculadora.ccf"
                          name="calculadora.ccf"
                          @input="calcularPrecio"
                        >  </b-form-checkbox></td>
                      <td>Ccf</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>
                        <b-form-checkbox
                          id="calculadora.afp"
                          v-model="calculadora.afp"
                          name="calculadora.afp"
                          @input="calcularPrecio"
                        >  </b-form-checkbox></td>
                      <td>Afp</td>
                      <td></td>
                    </tr>
                    <tr v-for="(items,index) in calculadora.multiples" :key="'calcmultiples'+index">
                      <td>
                        <b-form-checkbox
                          :id="'calculadora.check.'+items.name"
                          :name="'calculadora.check.'+items.name"
                          @input="calcularPrecio"
                          v-model="items.check"
                        >  </b-form-checkbox></td>
                      <td>{{items.name}}</td>
                      <td>
                        <vue-numeric 
                          v-show="items.check"
                          separator="."   
                          class="form-control"   
                          :empty-value="0"        
                          :id="'calculadora.valor.'+items.name"
                          :name="'calculadora.valor.'+items.name"
                          v-model="items.valor"
                          :precision="0">
                        </vue-numeric>  
                      </td>
                    </tr>
                    <tr style="border-top:1px solid">
                      <td></td>
                      <td style="padding-top:5px;font-weight:bold">Total</td>
                      <td style="padding-top:5px;font-weight:bold">$ {{totalCalculadora}}</td>
                    </tr>
                  </tbody>
                </table>              
              </b-popover>
            </b-col>          
          </b-row>
        </div>
        <div style="position: absolute;right: 67px;">
          <b-dropdown id="dropdown-right" right text="Menú usuario" variant="primary">
            <b-dropdown-item @click="instructivoPdf" >Instructivo</b-dropdown-item>
            <b-dropdown-item @click="nuevoModal" >Configuración</b-dropdown-item>
            <b-dropdown-item @click="logout">Cerrar Sesión</b-dropdown-item>
          </b-dropdown>
        </div>
      </b-navbar>      
    </header>
    <header  v-if="windowSize<992" class="sw-header pt-0" style="height:inherit;">
      <b-row style="background: url(../images/acuario.png) !important;">            
        <b-col :sm="3" :cols="3">
          Afil: <span class="text-info " style="font-weight:500">{{conteoData.afiliaciones}}</span>
        </b-col>
        <b-col :sm="3" :cols="3">
          Ret: <span class="text-danger " style="font-weight:500">{{conteoData.retiros}}</span>
        </b-col>
        <b-col :sm="3" :cols="3">
          Apor: <span class="text-info " style="font-weight:500">{{conteoData.aportes}}</span>
        </b-col>
        <b-col :sm="3" :cols="3">
          Pend: <span class="text-danger " style="font-weight:500">{{conteoData.pendientes}}</span>
        </b-col>
      </b-row> 
      <b-row class="mt-2">
        <b-col :cols="12" :sm="12" > 
            <img @click="oninit" src="images/logomenu.svg" style="width:120px;margin-right:20px">
            <b-icon id="popover-caluculado" icon="file-spreadsheet" variant="light" scale="1.7"></b-icon>            
            <b-popover target="popover-caluculado" triggers="click" placement="bottom">
              <template v-slot:title>Calculadora</template>
                <b-input-group prepend="Salario" class="mt-3">
                  <vue-numeric 
                  separator="."   
                  class="form-control"   
                  :empty-value="0"        
                  id="'calculadora.salario"
                  name="'calculadora.salario"
                  v-model="salarioCalculadora"
                  :precision="0">
                </vue-numeric>  
                  <b-button variant="outline-info" size="sm"  @click="calcularPrecio"><b-icon id="popover-caluculado" icon="file-spreadsheet" variant="dark" /></b-button>
                  <b-button variant="dark" size="sm"  @click="salarioCalculadora=baseCalculadora[0].base;calcularPrecio()"><b-icon id="popover-caluculado" icon="arrow-clockwise" variant="light" /></b-button>                   
              </b-input-group> 
              <table style="margin:auto;margin-top:15px">               
                <tbody>
                  <tr>
                    <td>
                      <b-form-checkbox
                        id="calculadora.eps"
                        v-model="calculadora.eps"
                        name="calculadora.eps"
                        @input="calcularPrecio"
                      >  </b-form-checkbox></td>
                    <td>Eps</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>
                      <b-form-checkbox
                        id="calculadora.arl"
                        v-model="calculadora.arl"
                        name="calculadora.arl"
                        @input="calcularPrecio"
                      >  </b-form-checkbox></td>
                    <td>Riesgo</td>
                    <td>
                      <c-multiselect
                        style="display:inline-block;flex: 1 1 0%; margin-bottom:15px"   
                        v-model="calculadora.riesgo"                   
                        :options="lists.list_riesgo"
                        @input="calcularPrecio"
                        label="name"
                        track-by="name"
                        :allow-empty="false"
                        placeholder="Seleccionar"
                        >
                      </c-multiselect>
                  </td>
                  </tr>
                  <tr>
                    <td>
                      <b-form-checkbox
                        id="calculadora.ccf"
                        v-model="calculadora.ccf"
                        name="calculadora.ccf"
                        @input="calcularPrecio"
                      >  </b-form-checkbox></td>
                    <td>Ccf</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>
                      <b-form-checkbox
                        id="calculadora.afp"
                        v-model="calculadora.afp"
                        name="calculadora.afp"
                        @input="calcularPrecio"
                      >  </b-form-checkbox></td>
                    <td>Afp</td>
                    <td></td>
                  </tr>
                  <tr v-for="(items,index) in calculadora.multiples" :key="'calcmultiples'+index">
                    <td>
                      <b-form-checkbox
                        :id="'calculadora.check.'+items.name"
                        :name="'calculadora.check.'+items.name"
                        @input="calcularPrecio"
                        v-model="items.check"
                      >  </b-form-checkbox></td>
                    <td>{{items.name}}</td>
                    <td>
                      <vue-numeric 
                        v-show="items.check"
                        separator="."   
                        class="form-control"   
                        :empty-value="0"        
                        :id="'calculadora.valor.'+items.name"
                        :name="'calculadora.valor.'+items.name"
                        v-model="items.valor"
                        :precision="0">
                      </vue-numeric>  
                    </td>
                  </tr>
                  <tr style="border-top:1px solid">
                    <td></td>
                    <td style="padding-top:5px;font-weight:bold">Total</td>
                    <td style="padding-top:5px;font-weight:bold">$ {{totalCalculadora}}</td>
                  </tr>
                </tbody>
              </table>              
            </b-popover>
            <span class="text-white" style="float:right"> Hola, {{nameMovil(user.name)}} </span> 
        </b-col>
        <b-col :cols="12" :sm="12" style="padding:0">  
          <b-row>
            <b-col :cols="10" :sm="10" style="padding:0">
              <b-navbar toggleable="lg" style="background: #0063CC" type="dark">
                  <b-navbar-brand href="#" style="width:100%;margin-right:0">
                    <b-input-group size="sm">
                        <c-multiselect
                          style="flex: 1 1 auto;max-width: 200px"             
                          id="buscarHeader"
                          name="buscarHeader"
                          class="buscarHeaderMovil"
                          placeholder=""
                          v-model="buscarHeader"        
                          :options="filterSelects('datos_afiliado')"
                          :filterCampos="'name|documento'"
                          :customLabel="function (value) { return value.documento+' - '+value.name}"
                          :allow-empty="false"          
                          label="name"
                          @input="searchsHeaderFtn"
                          >
                        </c-multiselect> 
                        <b-input-group-append>
                          <b-button @click="buscarHeader=[];dataGet.header.data=[]" variant="secondary" style="height: 31px;" size="sm">X</b-button>
                        </b-input-group-append>
                    </b-input-group>
                  </b-navbar-brand>
                </b-navbar> 
                <b-card v-if="buscarHeader>0" style="position:absolute;top:45px;z-index:20;background: rgb(250, 250, 250);    box-shadow: 0px 2px 9px 4px rgba(0, 0, 0, 0.08), 0px 3px 4px 0px rgba(0, 0, 0, 0.08), 0px 1px 7px 0px rgba(0, 0, 0, 0.08) !important;max-height: 500px;overflow:auto"  id="style-1"> 
                  <sw-loading v-if="dataGet.header.data.length===0"></sw-loading>              
                  <sw-tableheader
                    v-if="dataGet.header.data.length>0"
                    class="table-header-searchs"
                    :tableItems="tableGBItems"
                    :buscarProp="false"
                    :options="false"
                    name="tableheaderHeader"
                    :paginationShow="false"
                    >       
                  </sw-tableheader>
                </b-card>
            </b-col>
            <b-col  :cols="2" :sm="2" style="padding:0">
              <div style="font-size: 2rem;">
                <b-icon icon="justify" scale="2" @click="updateGlobal({state: 'openMenuMovil', data: true })" variant="light" class="border border-info rounded p-2"></b-icon>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>    
    </header>
    <!--<header class="sw-header sw-header-fixed">
      <b-navbar style="padding-left: 0;"  toggleable="lg">
        <div class="logo">
          <img src="images/logo-white.svg">
        </div>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-navbar-nav class="sw-header-nav">
          <b-nav-form style="margin-right:40px">
            <b-input-group size="sm"  prepend="Buscar paciente:">
                <b-form-input></b-form-input>
            </b-input-group>
          </b-nav-form>
         
        </b-navbar-nav> 
        <div style="position: absolute;right: 67px;">
          <b-dropdown id="dropdown-right" right text="Menú usuario" variant="primary">
            <b-dropdown-item @click="logout">Cerrar Sesión</b-dropdown-item>
          </b-dropdown>
        </div>
      </b-navbar>
    </header>-->
    <b-modal 
      v-if="openModal.modal.modal==='Configuracion'"
      v-model="openModal.modal.value"
      :title="openModal.modal.title" 
      :header-bg-variant="'primary'"
      header-text-variant="light"
      :hide-footer="true"  
      :no-close-on-backdrop="true" 
      size="lg"  
      >        
        <sw-modalusuarios 
          @save="saveForm"                     
          >
        </sw-modalusuarios>      
    </b-modal>     
  </div>  
</template>

<script>
import Multiselect  from '@/components/vue-multiselect/src/'
import { mapActions, mapState } from 'vuex';
import SwTableheader from '@/components/dataTable/tableHeader.vue'
import SwLoading from '@/components/notification/loading.vue'
import SwModalusuarios from '@/components/modals/usuarios.vue'
import VueNumeric   from '@/components/vue-numeric/vue-numeric.vue'
export default {
  name: "center-layout",  
  components: {   
    SwTableheader,  
    'c-multiselect': Multiselect,
    VueNumeric,
    SwLoading,
    SwModalusuarios
  },
  async created()
  {
    this.baseCalculadora = await this.buscarIdb({tabla:'base', campo: 'id', value: 1})
    this.salarioCalculadora=this.baseCalculadora[0].base
    this.preciosCalculadora = await this.buscarIdb({tabla:'precios', campo: 'id_datos_contacto', value: 1})
    let calcmultiples=   await this.buscarIdb({tabla: 'multiple_servicios', campo: 'lock', value: 0}) 
    this.calculadora.multiples = calcmultiples.filter(list => list.name!='Administración' && list.name!='Traslado')   
  },

  data()
  {
    return {
      calculadora: {
        eps: false,
        arl:false,
        riesgo: 1,
        ccf: false,
        afp: false,
        multiples: []
      },
      moraCliente: false,
      preciosCalculadora: [],
      baseCalculadora:[],
      salarioCalculadora: 0,
      totalCalculadora: 0,
      buscarHeader: [],      			
			tableGBItems: [
				{
					thead: { th: 'Documento', movil: true},
					tbody: { td: ['list_documento/name','datos_afiliado/documento'],}
				},
				{
					thead: { th: 'Nombres',},
					tbody: { td: ['datos_afiliado/name'],}
				},
				{
					thead: { th: 'Razón',},
					tbody: { td: ['datos_razon/name'],}
				},
				{
					thead: { th: 'Asesor',},
					tbody: { td: ['datos_asesor/name'],ftn: function(value) { let name=value.split(' '); if(name.length>1){ return name[0]+' '+name[1]}else{return name[0]}}}
				},
				{
					thead: { th: 'Teléfonos',},
					tbody: { td: ['datos_afiliado/telefonos'],}
				},
				{
					thead: { th: 'Ficha', movil: true},
					tbody: { td: ['datos_afiliado/id'], link: '/api/pdf/ficha'}
				},
				{
					thead: { th: 'Servicios' },
					tbody: { table: {
						  value: false,
							tabla: 'servicios_activos',
							search: ['name'],						
							items: [
								{
									thead: { th: 'Servicio'},
									tbody: {td: ['name']},
								},	
								{
									thead: { th: 'Entidad'},
									tbody: {td: ['id_list']},
								},
								{
									thead: { th: 'Inicio L.'},
									tbody: {td: ['iniciolabores']},
								},
								{
									thead: { th: 'Afiliación'},
									tbody: {td: ['afiliacion']},
								},
								{
									thead: { th: 'Valor'},
									tbody: {td: ['valor']},
								},
								{
									thead: { th: 'Prox. aporte'},
									tbody: {td: ['mes_periodo','ano_periodo']},
								},
								{
									thead: { th: 'Archivo'},
									tbody: {td: ['archivo']	, link:'/files', archivo: true},
								},						
							]
						}
					}
				},
				{
					thead: { th: 'Valor',},
					tbody: { td: ['servicios_activos'], ftn: function nameServicios(value){ let valor=0;for(let i=0;i<value.length;i++){ valor=valor+value[i].valor} return valor}}
        },	
        {
					thead: { th: 'Documentos'},
					tbody: { table: {
						  value: false,
							tabla: 'afiliado_documentos',
							search: ['name'],						
							items: [
                {
                  thead: { th: 'Nombre del Documento'},
                  tbody: { td: ['name'],}
                },
                {
                  thead: { th: 'Archivo', },
                  tbody: { td: ['archivo'], link:'/files', archivo: true}
                },
                {
                  thead: { th: 'Radicador', },
                  tbody: { td: ['list_users/name'], ftn: function(value) { return value.split(' ')[0]}}
                },				
							]
						}
					}
				},
				{
					thead: { th: 'Beneficiarios'},
					tbody: { table: {
						  value: false,
							tabla: 'afiliado_beneficiarios',
							search: ['name'],						
							items: [
                {
                  thead: { th: 'Documento'},
                  tbody: { td: ['list_documento/name','documento'],}
                },
                {
                  thead: { th: 'Beneficiario'},
                  tbody: { td: ['name'],}
                },
                {
                  thead: { th: 'Nacimiento', },
                  tbody: { td: ['nacimiento'],}
                },
                {
                  thead: { th: 'Servicios', },
                  tbody: { td: ['servicios'], ftn: function (items) { let servicios= JSON.parse(items);let name=''; for (let i = 0; i < servicios.length; i++) {
                    name = name+' '+servicios[i].name;                    
                  } return name} }
                },
                {
                  thead: { th: 'Radicador', },
					        tbody: { td: ['list_users/name'], ftn: function(value) { return value.split(' ')[0]}}
                },					
							]
						}
					}
				},
				{
					thead: { th: 'Afiliaciones', movil: true},
					tbody: { table: {
						  value: false,
							tabla: 'afiliacion_registro',
							search: ['name'],						
							items: [
							  {
                  thead: { th: 'Documento'},
                  tbody: { td: ['info_ingresos/documento',]}
                },
                {
                  thead: { th: 'Nombre'},
                  tbody: { td: ['info_ingresos/name'],}
                },
                {
                  thead: { th: 'Asesor', },
                  tbody: { td: ['datos_asesor/name'],}
                },
                {
                  thead: { th: 'Fecha' , movil: true},
                  tbody: { td: ['info_ingresos/fecha'],}
                },
                {
                  thead: { th: 'Valor', movil: true },
                  tbody: { td: ['info_ingresos/valor']}
                },
                {
                  thead: { th: 'Reporte', },
                  tbody: { td: ['info_ingresos/reporte']}
                },
                {
                  thead: { th: 'Forma', },
                  tbody: { td: ['list_forma/name']}
                },
                {
                  thead: { th: 'Cuenta', },
                  tbody: { td: ['list_cuentas/name','info_ingresos/consignacion'], show: {td: 'info_ingresos/id_list_forma', compare: 1, else: ''}}
                },
                {
                  thead: { th: 'Registro', movil: true },
                  tbody: { td: ['info_ingresos/id'], link: '/api/pdf/registro', show: {td: 'info_ingresos/anulado', compare: 0, else: 'Anulado'}}
                },				
							]
						}
					}
				},
				{
					thead: { th: 'Aportes', movil: true},
					tbody: { table: {
						  value: false,
							tabla: 'aportes_registro',
							search: ['list_mes/name'],						
							items: [
								{
                  thead: { th: 'Razón'},
                  tbody: { td: ['datos_razon/name'],}
                },
                {
                  thead: { th: 'Fecha', },
                  tbody: { td: ['info_aportes/fecha'],}
                },
                {
                  thead: { th: 'Asesor', },
                  tbody: { td: ['datos_asesor/name'],}
                },
                {
                  thead: { th: 'Novedad'},
                  tbody: { td: ['list_novedad/name']}
                },
                {
                  thead: { th: 'Valor', },
                  tbody: { td: ['info_aportes/valor']}
                },
                {
                  thead: { th: 'Forma', },
                  tbody: { td: ['list_forma/name']}
                },
                {
                  thead: { th: 'Cuenta', },
                  tbody: { td: ['list_cuentas/name','info_aportes/consignacion'], show: {td: 'info_aportes/id_list_forma', compare: 1, else: ''}}
                },
                {
                  thead: { th: 'Periodo', },
                  tbody: { td: ['list_mes/name','list_ano/name']}
                },
                {
                  thead: { th: 'Registro', },
                  tbody: { td: ['info_aportes/id'], link: '/api/pdf/registroaportes', show: {td: 'info_aportes/anulado', compare: 0, else: 'Anulado'}}
                },					
							]
						}
					}
				},
				/*{
					thead: { th: 'Incapacidades'},
					tbody: { table: {
						  value: false,
							tabla: 'servicios_activos',
							search: ['name'],						
							items: [
								{
									thead: { th: 'Servicio'},
									tbody: {td: ['name']},
								},	
								{
									thead: { th: 'Entidad'},
									tbody: {td: ['id_list']},
								},
								{
									thead: { th: 'Afiliación'},
									tbody: {td: ['afiliacion']},
								},
								{
									thead: { th: 'Radicado'},
									tbody: {td: ['archivo']	, link:'/files', archivo: true},
								},						
							]
						}
					}
        },*/        
				{
					thead: { th: 'Notas P.'},
					tbody: { table: {
						  value: false,
							tabla: 'notas_pendientes',
							search: ['name'],						
							items: [
                {
                  thead: { th: 'Nota'},
                  tbody: { td: ['nota'],}
                },
                {
                  thead: { th: 'Fecha Creación'},
                  tbody: { td: ['updated_at'],}
                },
                {
                  thead: { th: 'Periodo'},
                  tbody: { td: ['list_mes/name','id_list_ano'],}
                },
                {
                  thead: { th: 'Radicador', },
					        tbody: { td: ['list_users/name'], ftn: function(value) { return value.split(' ')[0]}}
                },					
							]
						}
					}
				},
      ],	
    }
  },
  computed: 
  {
    ...mapState({
        conteoData: state => state.crudStore.conteoData, 
    }),
  },
  methods: 
  {  
    ...mapActions({
        logout:   'authStore/logout',
        deleteDatabase:  'crudStore/deleteDatabase',
    }),
    resumenLink()
    {
      	window.open( this.url+'/api/pdf/resumenPago?token='+this.token,'_blank')
    },
		filterSelects(list)
		{
			return this.lists[list].filter(list => list.documento!=0)
		},
    async searchsHeaderFtn()
    {
      this.dataGet.header.data=[]
      let getBackend = await this.getData({route: 'buscar_afiliado_get', data: this.buscarHeader})
      await this.updateCrud({state: 'dataGet/header/data',data: [getBackend]})			
    },    
    async oninit()
    {
        await this.deleteDatabase()
        this.$emit('init')
    },      	
		nuevoModal()
		{
		  this.resetDataIndex()
		  this.updateGlobal({state: 'openModal/modal/value',    data: true });
		  this.updateGlobal({state: 'openModal/modal/title',    data: 'Datos Usuario'});
		  this.updateGlobal({state: 'openModal/modal/modal',    data: 'Configuracion'});
    },
    saveForm()
    {
      
    },
    instructivoPdf()
    {
      window.open( this.url+'/files/instructivo.pdf','_blank')
    },
    nameMovil(value) {
      let name=value.split(' ');return name[0] 
    },
    calcularPrecio()
    {
      try {
        let total=0
        let admin=0
        let eps=this.redondeaValue(100,parseInt(this.salarioCalculadora*this.baseCalculadora[0].epsexo/100),1)+parseInt(this.salarioCalculadora*this.baseCalculadora[0].epsexo/100)
        let ccf=this.redondeaValue(100,parseInt(this.salarioCalculadora*this.baseCalculadora[0].ccf/100),1)+parseInt(this.salarioCalculadora*this.baseCalculadora[0].ccf/100)
        let afp=this.redondeaValue(100,parseInt(this.salarioCalculadora*this.baseCalculadora[0].afp/100),1)+parseInt(this.salarioCalculadora*this.baseCalculadora[0].afp/100)
        let riesgo=this.redondeaValue(100,parseInt(this.salarioCalculadora*this.baseCalculadora[0]['r'+this.calculadora.riesgo]/100),1)+parseInt(this.salarioCalculadora*this.baseCalculadora[0]['r'+this.calculadora.riesgo]/100)
        let precios =this.preciosCalculadora.filter(list => list.id_list_riesgo.toString()===this.calculadora.riesgo.toString() && list.exonerado===1)
        if(this.calculadora.eps && this.calculadora.ccf && this.calculadora.afp)
        {
            total=precios[0].epsarlccfafp+eps+riesgo+ccf+afp
        }
        if(this.calculadora.eps && !this.calculadora.ccf && this.calculadora.afp)
        {
            total=precios[0].epsarlafp+eps+riesgo+afp
        }
        if(this.calculadora.eps && this.calculadora.ccf && !this.calculadora.afp)
        {
            total=precios[0].epsarlccf+eps+riesgo+ccf
        }
        if(this.calculadora.eps && !this.calculadora.ccf && !this.calculadora.afp)
        {
            total=precios[0].epsarl+eps+riesgo
        }
        for (let i = 0; i <this.calculadora.multiples.length; i++) {
          if(this.calculadora.multiples[i].check)
          {
            total+=this.calculadora.multiples[i].valor
          }        
        }
        let sobrante2=this.redondeaValue(1000,total,1,1)
        if(sobrante2>0)
        {
            total=total+sobrante2
        }
        this.totalCalculadora=total
        return true
      }
      catch(e) {
        console.log(e)
      }
     
    }
  }
  
};
</script>

<style lang="scss">
.sw-header-fixed
{
    width: 100%;
    position: fixed;
    z-index: 3;
}
.dropdown-item.active, .dropdown-item:active {
    background-color: #fff !important;
    border-color: #fff !important;
    color: #343434 !important;
}
.sw-header {
  padding-top: 5px;
  background: #0063CC;
  height: 65px;
  flex-shrink: 0;
  box-shadow: 0 0.5rem 1rem rgba(0,0,0,.05), inset 0 -1px 0 rgba(0,0,0,.1);
}
.sw-header .logo {
  text-align:center;
  width: 200px;
}
.sw-header .logo img{
  width: 85px;
  height: 100%;
}
.sw-header-nav .nav-item a{
  color: #f8f9fa !important;
}
.sw-header-nav .nav-item a.dropdown-item{
  color: #212529 !important;
}
.sw-header-nav .nav-item a.dropdown-item:active{
  color: white !important;
}
.bg-sw{
  background: #563d7c
}
.sw-header-nav .nav-item .sw-path-active a.dropdown-item:active
{
  color: #f8f9fa !important;
  background-color: #563d7c;
}
.buscarHeader
{
  margin-bottom:15px!important;
  width:auto !important;
  min-width: 250px
}
.buscarHeader .multiselect__tags
{
  border-radius:0 !important
}
.table-header-searchs .table--get
{
   font-size: 13px !important;  
}

#style-1::-webkit-scrollbar-track
{
	box-shadow: inset 0 0 6px rgba(0,0,0,0.25);
	border-radius: 10px;
	background-color: #F5F5F5;
}

#style-1::-webkit-scrollbar
{
	width: 8px;
	background-color: #F5F5F5;
}
.buscarHeaderMovil .multiselect__content-wrapper{
  width:  290px;
}

#style-1::-webkit-scrollbar-thumb
{
	border-radius: 10px;
	box-shadow: inset 0 0 6px rgba(0,0,0,.25);
	background-color: #555;
}
.resumen {
  width: 155px;
  margin: auto;
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.9);
}
.resumen-limite{
  display:block;
  font-size:12px
}
</style>

